module.exports = __webpack_public_path__ + "media/images/image-2-2b12ff69.jpg";